// extracted by mini-css-extract-plugin
module.exports = {"toggle":"ToggleButton_toggle__1IwfA","toggleOn":"ToggleButton_toggleOn__3MVeu","toggleButton":"ToggleButton_toggleButton__1ZBmd","toggleText":"ToggleButton_toggleText__hPrTh"};